export default __webpack_public_path__ + "static/media/034-telescope.0356cc39.png";